import { OutboundLink } from "./Map";
//import { ViewSelector } from "./ViewSelector";

/*function formatTopicAndRemoveParams(topic) {
  // Replace spaces in the topic with dashes
  const formattedTopic = topic.replace(/\s+/g, "-");
  return formattedTopic;
}

function removeTrackingParamsFromURL(url) {
  const urlObject = new URL(url);
  const trackingParams = ["_ga", "_gl"]; // Add other parameters to remove if needed

  trackingParams.forEach((param) => {
    urlObject.searchParams.delete(param);
  });

  return urlObject.toString();
} */

export const ArticleDetail = ({ selectedArticle, referrer, isMobile }) => {
  //console.log("Selected Region is: ", selectedArticle[0].N);
  if (
    !!selectedArticle &&
    typeof selectedArticle === "object" &&
    !!selectedArticle[0].Title
  ) {
    return (
      <div className="article-detail is-open">
        <div>
          <h4> {selectedArticle[0].N}</h4>
          {/*<h5>{selectedArticle[0].C} stories connected to this Neighborhood</h5>*/}
          <h5 className="chart-note source-content byline-content">
            <b>Latest Articles connected to this neighborhood: </b>
          </h5>
          <div className="chart-note source-content byline-content">
            <div>
              <ul style={{ listStyleType: "circle", paddingLeft: 0 }}>
                {selectedArticle.map((obj, index) => {
                  const titles = obj.Title.split("|");
                  const urls = obj.U.split("|");
                  return titles.slice(0, 5).map((title, i) => (
                    <li key={i} style={{ color: "blue" }}>
                      <a
                        href={`https://thecity.nyc${urls[i].trim()}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <strong>{title}</strong>
                      </a>
                    </li>
                  ));
                })}
              </ul>
            </div>
          </div>
          {/*
          <h5 className="chart-note source-content byline-content">
            <b>
              Here are the beats most covered in this neighborhood. Click to see
              more stories for the beat.
            </b>
          </h5>
          <div className="chart-note source-content byline-content">
            <div>
              {selectedArticle.map((obj, index) => {
                const topics = obj.T;
                return topics.slice(0, 5).map((topic, i) => {
                  const formattedTopic = formatTopicAndRemoveParams(topic);
                  const cleanURL = removeTrackingParamsFromURL(
                    `https://www.thecity.nyc/category/${formattedTopic}/`
                  );

                  return (
                    <div
                      key={i}
                      style={{
                        backgroundColor: "#08519c",
                        color: "white",
                        padding: "3px",
                        margin: "5px",
                        display: "inline-block",
                      }}
                    >
                      <a
                        href={cleanURL}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ textDecoration: "none", color: "inherit" }}
                      >
                        <strong>{topic}</strong>
                      </a>
                    </div>
                  );
                });
              })}
            </div>
            </div> */}
        </div>
        <div className="divider" />
        <p className="chart-note">
          If you spot an error, please let us know at{" "}
          <OutboundLink to="mailto:data@thecity.nyc" referrer={referrer}>
            data@thecity.nyc
          </OutboundLink>
          .
        </p>
        {/* <div className="divider" /> */}
        <p className="chart-note source-content">
          <OutboundLink
            to="https://www.thecity.nyc/legal/privacy-notice"
            referrer={referrer}
          >
            Privacy Notice
          </OutboundLink>
        </p>
        <></>
      </div>
    );
  } else if (!!selectedArticle && typeof selectedArticle === "object") {
    return (
      <div className="article-detail is-open">
        <div>
          <h4> {selectedArticle[0].N}</h4>
        </div>
      </div>
    );
  } else {
    return (
      // <div className="article-detail is-open">
      //   <div>
      //     <></>
      //     <p className="chart-note source-content"></p>
      //   </div>
      //   <div className="divider" />
      //   <>
      //     <p> </p>
      //   </>
      //   <p className="chart-note">
      //     If you spot an error, please let us know at{" "}
      //     <OutboundLink to="mailto:data@thecity.nyc" referrer={referrer}>
      //       data@thecity.nyc
      //     </OutboundLink>
      //     .
      //   </p>
      //   <div className="divider" />
      //   <p className="chart-note source-content">
      //     <OutboundLink
      //       to="https://www.thecity.nyc/legal/privacy-notice"
      //       referrer={referrer}
      //     >
      //       Privacy Notice
      //     </OutboundLink>
      //   </p>
        <></>
      // </div>
    );
  }
};

export const PointArticleDetail = ({ selectedArticle, referrer }) => {
  //console.log("Selected Region is: ", selectedArticle[0].N);
  if (!!selectedArticle) {
    //console.log("We are here:");
    return (
      <div className="article-detail is-open">
        <div>
          <></>
          <p className="chart-note source-content"></p>
        </div>
        <div className="divider" />
        <p className="chart-note">
          If you spot an error, please let us know at{" "}
          <OutboundLink to="mailto:data@thecity.nyc" referrer={referrer}>
            data@thecity.nyc
          </OutboundLink>
          .
        </p>
        <div className="divider" />
        <p className="chart-note source-content">
          <OutboundLink
            to="https://www.thecity.nyc/legal/privacy-notice"
            referrer={referrer}
          >
            Privacy Notice
          </OutboundLink>
        </p>
        <></>
      </div>
    );
  }
};

/**
 * This array lists out the names of NTAs by the order of their ID code.
 * For example, the NTA with id code `14` is the 14th element if this array,
 * and can be accessed by calling `NtaNamesOrdered[13]`.
 */

/*
const NtaNamesOrdered = [
  "Midwood",
  "Bedford",
  "Fordham South",
  "Borough Park",
  "Rugby-Remsen Village",
  "East Flushing",
  "Woodhaven",
  "Madison",
  "Auburndale",
  "Williamsbridge-Olinville",
  "Murray Hill",
  "East Elmhurst",
  "Brownsville",
  "East New York (Pennsylvania Ave)",
  "Kensington-Ocean Parkway",
  "Parkchester",
  "Erasmus",
  "Cambria Heights",
  "East Flatbush-Farragut",
  "Ocean Parkway South",
  "Starrett City",
  "Morrisania-Melrose",
  "Elmhurst",
  "East Village",
  "Glen Oaks-Floral Park-New Hyde Park",
  "Longwood",
  "Yorkville",
  "Upper East Side-Carnegie Hill",
  "Windsor Terrace",
  "Hammels-Arverne-Edgemere",
  "Rikers Island",
  "Hunts Point",
  "Jackson Heights",
  "Bath Beach",
  "Old Town-Dongan Hills-South Beach",
  "Flatbush",
  "Melrose South-Mott Haven North",
  "Ocean Hill",
  "Morningside Heights",
  "Soundview-Bruckner",
  "Allerton-Pelham Gardens",
  "Jamaica Estates-Holliswood",
  "Hollis",
  "Flatlands",
  "East New York",
  "Kingsbridge Heights",
  "Springfield Gardens North",
  "Canarsie",
  "Norwood",
  "Manhattanville",
  "West Village",
  "Grasmere-Arrochar-Ft. Wadsworth",
  "Queens Village",
  "Chinatown",
  "Pelham Bay-Country Club-City Island",
  "Woodlawn-Wakefield",
  "Old Astoria",
  "Astoria",
  "Stuyvesant Town-Cooper Village",
  "Dyker Heights",
  "Bensonhurst West",
  "West New Brighton-New Brighton-St. George",
  "New Brighton-Silver Lake",
  "Westerleigh",
  "University Heights-Morris Heights",
  "Bayside-Bayside Hills",
  "Crown Heights North",
  "East Concourse-Concourse Village",
  "North Corona",
  "Cypress Hills-City Line",
  "Kew Gardens Hills",
  "Pomonok-Flushing Heights-Hillcrest",
  "North Side-South Side",
  "Lower East Side",
  "Greenpoint",
  "Spuyten Duyvil-Kingsbridge",
  "Sunset Park East",
  "Marble Hill-Inwood",
  "Homecrest",
  "Washington Heights North",
  "Steinway",
  "Mott Haven-Port Morris",
  "West Brighton",
  "Central Harlem North-Polo Grounds",
  "Queensbridge-Ravenswood-Long Island City",
  "New Dorp-Midland Beach",
  "Van Cortlandt Village",
  "Co-op City",
  "Bay Ridge",
  "Sunset Park West",
  "Fort Greene",
  "SoHo-TriBeCa-Civic Center-Little Italy",
  "Battery Park City-Lower Manhattan",
  "Clinton",
  "Prospect Heights",
  "Baisley Park",
  "South Jamaica",
  "Ozone Park",
  "Georgetown-Marine Park-Bergen Beach-Mill Basin",
  "Brighton Beach",
  "Bensonhurst East",
  "West Farms-Bronx River",
  "Sheepshead Bay-Gerritsen Beach-Manhattan Beach",
  "Westchester-Unionport",
  "Oakwood-Oakwood Beach",
  "Grymes Hill-Clifton-Fox Hills",
  "Park Slope-Gowanus",
  "Stapleton-Rosebank",
  "Fresh Meadows-Utopia",
  "Bellerose",
  "Stuyvesant Heights",
  "East Williamsburg",
  "Ridgewood",
  "East Harlem South",
  "Rego Park",
  "East Harlem North",
  "Bushwick North",
  "Bushwick South",
  "Central Harlem South",
  "College Point",
  "Midtown-Midtown South",
  "Glendale",
  "Charleston-Richmond Valley-Tottenville",
  "Parks, Cemeteries etc.-Staten Island",
  "New Springville-Bloomfield-Travis",
  "Todt Hill-Emerson Hill-Heartland Village-Lighthouse Hill",
  "South Ozone Park",
  "Lindenwood-Howard Beach",
  "Prospect Lefferts Gardens-Wingate",
  "Murray Hill-Kips Bay",
  "Mariner's Harbor-Arlington-Port Ivory-Graniteville",
  "Crown Heights South",
  "Brooklyn Heights-Cobble Hill",
  "Port Richmond",
  "Hunters Point-Sunnyside-West Maspeth",
  "Claremont-Bathgate",
  "Van Nest-Morris Park-Westchester Square",
  "Pelham Parkway",
  "Mount Hope",
  "Ft. Totten-Bay Terrace-Clearview",
  "Whitestone",
  "Turtle Bay-East Midtown",
  "Lenox Hill-Roosevelt Island",
  "Elmhurst-Maspeth",
  "Woodside",
  "St. Albans",
  "Laurelton",
  "Hamilton Heights",
  "Jamaica",
  "Richmond Hill",
  "Briarwood-Jamaica Hills",
  "Kew Gardens",
  "Middle Village",
  "Maspeth",
  "Upper West Side",
  "Lincoln Square",
  "Bronxdale",
  "Oakland Gardens",
  "Douglas Manor-Douglaston-Little Neck",
  "Annadale-Huguenot-Prince's Bay-Eltingville",
  "Great Kills",
  "Seagate-Coney Island",
  "Corona",
  "Schuylerville-Throgs Neck-Edgewater Park",
  "Gravesend",
  "East Tremont",
  "North Riverdale-Fieldston-Riverdale",
  "Bedford Park-Fordham North",
  "Belmont",
  "Eastchester-Edenwald-Baychester",
  "Breezy Point-Belle Harbor-Rockaway Park-Broad Channel",
  "Crotona Park East",
  "Rossville-Woodrow",
  "Arden Heights",
  "Far Rockaway-Bayswater",
  "Soundview-Castle Hill-Clason Point-Harding Park",
  "Parks, Cemeteries etc.-Bronx",
  "Carroll Gardens-Columbia Street-Red Hook",
  "Parks, Cemeteries etc.-Manhattan",
  "Rosedale",
  "Flushing",
  "Queensboro Hill",
  "Hudson Yards-Chelsea-Flatiron-Union Square",
  "Gramercy",
  "DUMBO-Vinegar Hill-Downtown Brooklyn-Boerum Hill",
  "Clinton Hill",
  "Williamsburg",
  "Parks, Cemeteries etc.-Brooklyn",
  "Washington Heights South",
  "Highbridge",
  "West Concourse",
  "Forest Hills",
  "Parks, Cemeteries etc.-Queens",
  "Springfield Gardens South-Brookville",
  "Airport",
];*/
